import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Paginator, Alert, Spinner } from 'patternfly-react';
import { FormattedMessage, defineMessages, injectIntl, intlShape } from 'react-intl';
import DataTypeListMenuActions from 'ui/data-types/list/DataTypeListMenuActions';
import DataTypeStatusIcon from 'ui/data-types/common/DataTypeStatusIcon';
import DeleteDataTypeModalContainer from 'ui/data-types/common/DeleteDataTypeModalContainer';
import DataTypeReferenceStatusContainer from 'ui/data-types/common/DataTypeReferenceStatusContainer';
import paginatorMessages from 'ui/paginatorMessages';

const msgs = defineMessages({
  dataTypeTableStatus: {
    id: 'dataType.table.status',
    defaultMessage: 'Status - {status}',
  },
});

class DataTypeListTable extends Component {
  constructor(props) {
    super(props);

    this.changePage = this.changePage.bind(this);
    this.changePageSize = this.changePageSize.bind(this);
  }

  componentWillMount() {
    this.props.onWillMount();
  }

  changePage(page) {
    this.props.onWillMount({ page, pageSize: this.props.pageSize });
  }

  changePageSize(pageSize) {
    this.props.onWillMount({ page: 1, pageSize });
  }

  renderTableRows() {
    const { datatypes, intl } = this.props;
    return datatypes.map(datatype => (
      <tr key={datatype.name}>
        <td className="DataTypeListRow__td">{datatype.name}</td>
        <td className="DataTypeListRow__td text-center">{datatype.code}</td>
        <td className="DataTypeListRow__td text-center">
          <DataTypeStatusIcon
            status={datatype.status}
            title={intl.formatMessage(msgs.dataTypeTableStatus, { status: datatype.status })}
          />
        </td>
        <td className="DataTypeListRow__td text-center">
          <DataTypeListMenuActions
            code={datatype.code}
            onClickDelete={this.props.onClickDelete}
            onClickReload={this.props.onClickReload}
          />
        </td>
      </tr>
    ));
  }

  renderTable() {
    const {
      datatypes, page, pageSize, intl,
    } = this.props;

    if (datatypes.length > 0) {
      const pagination = {
        page,
        perPage: pageSize,
        perPageOptions: [5, 10, 15, 25, 50],
      };

      const messages = Object.keys(paginatorMessages).reduce((acc, curr) => (
        { ...acc, [curr]: intl.formatMessage(paginatorMessages[curr]) }
      ), {});

      return (
        <Col xs={12}>
          <DataTypeReferenceStatusContainer />
          <table className="DataTypeListTable__table table table-striped table-bordered">
            <thead>
              <tr>
                <th><FormattedMessage id="app.name" /></th>
                <th className="DataTypeListTable__th-sm text-center">
                  <FormattedMessage id="app.code" />
                </th>
                <th className="DataTypeListTable__th-xs text-center">
                  <FormattedMessage id="dataType.table.status" />
                </th>
                <th className="DataTypeListTable__th-xs text-center">
                  <FormattedMessage id="app.actions" />
                </th>
              </tr>
            </thead>
            <tbody>
              {this.renderTableRows()}
            </tbody>
          </table>
          <Paginator
            pagination={pagination}
            viewType="table"
            itemCount={this.props.totalItems}
            onPageSet={this.changePage}
            onPerPageSelect={this.changePageSize}
            messages={messages}
          />
        </Col>
      );
    }
    return (
      <Col xs={12}>
        <Alert type="warning">
          <strong><FormattedMessage id="dataType.listEmpty" /></strong>
        </Alert>
      </Col>
    );
  }

  render() {
    return (
      <Spinner loading={this.props.loading} >
        <div className="DataTypeListTable">
          {this.renderTable()}
          <DeleteDataTypeModalContainer />
        </div>
      </Spinner>
    );
  }
}

DataTypeListTable.propTypes = {
  onWillMount: PropTypes.func,
  onClickDelete: PropTypes.func.isRequired,
  onClickReload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  datatypes: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  })),
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  intl: intlShape.isRequired,
};

DataTypeListTable.defaultProps = {
  onWillMount: () => {},
  loading: false,
  datatypes: [],
};

export default injectIntl(DataTypeListTable);
